import { useNavigation } from '@zet/common/hooks/useNavigation'
import {
  B5,
  BTN,
  Button,
  colors as zetColors,
  Icon,
  Stack,
  XStack,
} from '@zet/design-system'
import { i18n } from '@zet/localization'
import { LoggedInNavigation } from '@zet/utils/interface'

interface ReopenLeadProps {
  reopen?: boolean
  reopenDays?: number
  reopenDate?: string
  shareNewLink?: boolean
  inactive?: boolean
  leadId?: number
  leadStatus?: string
  userId?: number
  customerId?: number
  partnerId: number
  brandName?: string
  customerName?: string
  customerPhoneNumber?: string
}

const ReopenLead: React.FC<ReopenLeadProps> = (props) => {
  const { navigate } = useNavigation<LoggedInNavigation>()
  const {
    reopen,
    reopenDate,
    reopenDays,
    shareNewLink,
    inactive,
    leadId,
    leadStatus,
    userId,
    customerId,
    partnerId,
    brandName,
    customerName,
    customerPhoneNumber,
  } = props

  const handleShareCardLink = () => {
    navigate('ShareCardLink', {
      brandId: partnerId,
      customerName: customerName,
      customerPhoneNumber: customerPhoneNumber,
      customerId: customerId,
      reopen: true,
      routeName: 'forCustomerFlow',
      eventName: 'click_action',
      eventPayload: {
        item_name: 'lead_page_share_message_preview_screen_share',
        lead_id: leadId,
        lead_status: leadStatus,
        user_id: userId,
        customer_id: customerId,
        partner_id: partnerId,
        brand_name: brandName,
      },
    })
  }

  if (reopen) {
    return (
      <Stack>
        <XStack className="bg-grays-20 mx-3 my-2 rounded p-1">
          <Icon type={'AnnounceOutlined'} color={zetColors.grays[90]} />
          <B5 className="text-grays-60 flex-1">
            {reopenDays
              ? i18n.t('leads.restartRejectedLeadDesc', {
                  days: reopenDays,
                })
              : i18n.t('leads.restartLeadDesc')}
          </B5>
        </XStack>
        {!!reopenDate && (
          <Stack className="mx-3 my-2 items-center">
            <B5>
              {i18n.t('leads.restartRejectedLeadIn', {
                date: reopenDate,
              })}
            </B5>
          </Stack>
        )}
        <Stack className="mb-4/2 mx-3">
          <Button
            disabled={!shareNewLink || inactive ? true : false}
            fullWidth
            size={'md'}
            className={'px-3 py-2'}
            onPress={handleShareCardLink}
            eventName="click_action"
            eventPayload={{
              item_name: 'lead_page_share_new_link',
              lead_id: leadId,
              lead_status: leadStatus,
              user_id: userId,
              customer_id: customerId,
              partner_id: partnerId,
              brand_name: brandName,
            }}
          >
            {inactive ? (
              <XStack className="items-center">
                <BTN className=" text-neutral-white100">
                  {i18n.t('leads.inactiveShare')}
                </BTN>
              </XStack>
            ) : (
              <XStack className="items-center">
                <Icon
                  type="Share"
                  size={24}
                  color={zetColors.neutral['white100']}
                  className={'mr-2'}
                />
                <BTN className=" text-neutral-white100">
                  {i18n.t('leads.shareNewLink')}
                </BTN>
              </XStack>
            )}
          </Button>
        </Stack>
      </Stack>
    )
  }
  return null
}

export default ReopenLead
